/** @file scaleHandles: the scale tool's mesh, the centre cube (a key holds one uniform scale). */
import { CreateBox } from '@babylonjs/core/Meshes/Builders/boxBuilder.js';
import type { Scene } from '@babylonjs/core/scene.js';
import type { GizmoFrame, HandleSet } from './gizmoFrame';
import { GIZMO_METRICS as M } from './gizmoMetrics';
import type { GizmoNodes } from './gizmoNodes';
import { gizmoUnit } from './gizmoUnit';
import { handlePaint } from './handlePaint';
import { thinSolids } from './thinSolids';
import { VIEWPORT_GROUPS } from './viewportGroups';

/**
 * One `centreCube`-pixel cube at the origin of the axes frame (one thin instance of a `CreateBox` mesh). There are no
 * per-axis lines: a key's `scale` is one number, so an axis handle would only mislead (design 19.8, T-315).
 */
export function scaleHandles(scene: Scene, nodes: GizmoNodes): HandleSet {
  const cubes = thinSolids(CreateBox('viewport-gizmo-cubes', { size: 1 }, scene), nodes.frame, 1, 1, VIEWPORT_GROUPS.gizmo);
  const size = gizmoUnit(M.centreCube);
  cubes.matrices.set([size, 0, 0, 0, 0, size, 0, 0, 0, 0, size, 0, 0, 0, 0, 1]);
  cubes.markMatrices();
  return {
    lines: [],
    setEnabled: (on) => { cubes.mesh.setEnabled(on); },
    update: (f: GizmoFrame) => {
      cubes.mesh.setEnabled((f.show & 8) !== 0);
      cubes.paint(0, handlePaint(f, 3));
      cubes.commit();
    },
  };
}
